// extracted by mini-css-extract-plugin
module.exports = {"container":"mLsm4V4zs77RYfyputamR","idContainer":"_2RKJOUmWm-rYjxZ7zRoZAr","idContainer__id":"_2fbUOPyRuml-N-NNZTUdn8","idContainer__dv":"_2QS3UZujmHXZPw4E_7rqz0"};